import { render, staticRenderFns } from "./AppointmentCompleteWrapper.vue?vue&type=template&id=1913d428"
import script from "./AppointmentCompleteWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentCompleteWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports